module.exports = __webpack_public_path__ + "static/img/tenant-flow.3be8107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tenant-flow.png
// module id = +fbP
// module chunks = 1